import React from 'react';

export function itemTypes(types, prop) {
    const props = {
        itemScope: true,
        itemType: types.map((type) => `https://schema.org/${type}`).join(' ')
    };
    if (prop) {
        props.itemProp = prop;
    }
    return props;
}

export function itemType(type, prop) {
    return itemTypes([type], prop);
}

export function itemProps(props) {
    return Object.keys(props).map((name, index) =>
        (<meta key={index} itemProp={name} content={props[name]} />)
    );
}